export default function Home(){

    return(
        <>
        <h4>Department Page Here....</h4>
        </>
    )
}
